import React from "react";

const sparklesAnim = {
  position: "absolute",
  top: "8px",
  left: "8px",
  pointerEvents: "none",
};

const DailyGiftFloatingIcon = ({ onClick }) => {
  return (
    <button
      className="fixed left-6 z-40 bg-white hover:bg-pink-600 text-white rounded-full shadow-lg flex items-center justify-center w-16 h-16 transition-all duration-200"
      style={{
        boxShadow: "0 4px 16px rgba(244,114,182,0.25)",
        zIndex: 40,
        bottom: "calc(102px + env(safe-area-inset-bottom, 0px))",
      }}
      onClick={onClick}
      title="Daily Gift"
    >
      {/* Sparkles Animation */}
      <span style={sparklesAnim}>
        <svg width="28" height="28" viewBox="0 0 40 40" fill="none">
          <circle cx="8" cy="8" r="2" fill="#FFD700">
            <animate
              attributeName="r"
              values="2;4;2"
              dur="1.2s"
              repeatCount="indefinite"
            />
          </circle>
          <circle cx="32" cy="12" r="1.5" fill="#FFF700">
            <animate
              attributeName="r"
              values="1.5;3;1.5"
              dur="1.2s"
              repeatCount="indefinite"
            />
          </circle>
          <circle cx="20" cy="32" r="1.2" fill="#FFB700">
            <animate
              attributeName="r"
              values="1.2;2.5;1.2"
              dur="1.2s"
              repeatCount="indefinite"
            />
          </circle>
        </svg>
      </span>
      {/* User's SVG Gift Icon */}
      <img
        src="https://ik.imagekit.io/je2vkmmlbm/gift-box-icon.svg"
        alt="Daily Gift Icon"
        width={40}
        height={40}
        style={{ display: "block" }}
        draggable={false}
      />
      {/* ...existing code... */}
    </button>
  );
};

export default DailyGiftFloatingIcon;
